import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Menu,
  MenuItem,
  Typography,
  Box,
  Button,
  Grid,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";

const Navbar: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [megaMenuOpen, setMegaMenuOpen] = useState(false);
  const [TmegaMenuOpen, setTMegaMenuOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [megaMenuDrawerOpen, setMegaMenuDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const isMobile = useMediaQuery("(max-width:970px)");
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();

  // Scroll effect to change background on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const toggleDrawer = () => {
    setDrawerOpen((prev) => !prev);
  };

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  const toggleMegaMenuDrawer = () => {
    setMegaMenuDrawerOpen((prev) => !prev);
  };

  const handleRoute = (path: string) => {
    navigate(path);
  };

  const handleNavigation = (path: string) => {
    toggleDrawer();
    navigate(path);
  };

  const handleMegaMenuHover = (status: boolean) => {
    setMegaMenuOpen(status);
  };

  const handleTMegaMenuHover = (status: boolean) => {
    setTMegaMenuOpen(status);
  };
  return (
    <AppBar
      position="fixed"
      sx={{
        transition: "background-color 0.5s ease",
        backgroundColor: scrolled ? "#f3f4f6" : "transparent",
        boxShadow: scrolled ? "0px 4px 12px rgba(0, 0, 0, 0.1)" : "none",
        paddingBottom: scrolled ? "20px" : "0px",
        color: scrolled ? "#012e57" : "white",
      }}
    >
      <Toolbar
        sx={{
          top: 0,
          left: 0,
          right: 0,
          paddingTop: "20px",
          zIndex: 50,
        }}
      >
        <img
          src="logo22.png"
          alt="Logo"
          style={{
            height: isSmallScreen ? "40px" : "70px",
            width: isSmallScreen ? "40px" : "6%",
            marginRight: "10px",

          }}
        />
        <Typography
          variant="h6"
          component="div"
          onClick={() => handleRoute("/")}
          sx={{
            flexGrow: 1,
            fontSize: isSmallScreen ? "18px" : "22px",

            fontWeight: "bold",
            marginTop: "7px"
          }}
        >
          Matt Scholar Solutions
        </Typography>

        {isMobile ? (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer}
          >
            <MenuIcon />
          </IconButton>
        ) : (
          <Box sx={{ flexGrow: 2 }}>
            <Button color="inherit" href="/">
              Home
            </Button>
            <Button color="inherit" href="/About">
              About
            </Button>

            <Button
              color="inherit"
              onMouseEnter={() => handleMegaMenuHover(true)}
              onMouseLeave={() => handleMegaMenuHover(false)}
            >
              Services
            </Button>

            {megaMenuOpen && (
              <Box
                sx={{
                  position: "absolute",
                  top: "70px",
                  left: "40%",
                  width: "40%",
                  backgroundColor: "#f3f4f6",
                  color: "#172554",
                  zIndex: 10,
                  padding: isSmallScreen ? "8px" : "16px",
                  backdropFilter: "blur(5px)",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: "-10px",
                    left: "30%",
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "10px solid transparent",
                    borderRight: "10px solid transparent",
                    borderBottom: "10px solid #f3f4f6",
                  },
                }}
                onMouseEnter={() => handleMegaMenuHover(true)}
                onMouseLeave={() => handleMegaMenuHover(false)}
              >
                <Grid container spacing={1} p={1}>
                  {/* First Column */}
                  <Grid item xs={12} sm={6}>
                    <List>
                      <ListItem
                        button
                        onClick={() =>
                          handleRoute("/dissertation-writing-services")
                        }
                      >
                        <ListItemIcon
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <img
                            src="4725551.webp"
                            alt="Dissertation Icon"
                            style={{ width: 40, height: 40 }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Typography
                              sx={{
                                fontSize: isSmallScreen ? "14px" : "17px",
                              }}
                            >
                              Dissertation
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem
                        button
                        onClick={() => handleRoute("/coursework-writing")}
                      >
                        <ListItemIcon
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <img
                            src="courses.webp"
                            alt="Coursework Icon"
                            style={{ width: 40, height: 40 }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Typography
                              sx={{
                                fontSize: isSmallScreen ? "14px" : "17px",
                              }}
                            >
                              Coursework
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem
                        button
                        onClick={() => handleRoute("/data-analysis-services")}
                      >
                        <ListItemIcon
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <img
                            src="data.webp"
                            alt="Data Analysis Icon"
                            style={{ width: 40, height: 40 }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Typography
                              sx={{
                                fontSize: isSmallScreen ? "14px" : "17px",
                              }}
                            >
                              Data Analysis
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem
                        button
                        onClick={() => handleRoute("/project-report-writing")}
                      >
                        <ListItemIcon
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <img
                            src="edit.webp"
                            alt="Editing Services Icon"
                            style={{ width: 40, height: 40 }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Typography
                              sx={{
                                fontSize: isSmallScreen ? "14px" : "17px",
                              }}
                            >
                              Project writing services
                            </Typography>
                          }
                        />
                      </ListItem>
                    </List>
                  </Grid>

                  {/* Second Column */}
                  <Grid item xs={12} sm={6}>
                    <List>
                      <ListItem
                        button
                        onClick={() => handleRoute("/publication-services")}
                      >
                        <ListItemIcon
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <img
                            src="9490625.webp"
                            alt="Courses Icon"
                            style={{ width: 40, height: 40 }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Typography
                              sx={{
                                fontSize: isSmallScreen ? "14px" : "17px",
                              }}
                            >
                              Publication
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem
                        button
                        onClick={() =>
                          handleRoute("/literature-review-writing")
                        }
                      >
                        <ListItemIcon
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <img
                            src="lit.webp"
                            alt="Literature Review Icon"
                            style={{ width: 40, height: 40 }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Typography
                              sx={{
                                fontSize: isSmallScreen ? "14px" : "17px",
                              }}
                            >
                              Literature Review
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem
                        button
                        onClick={() => handleRoute("/manuscript-preparation")}
                      >
                        <ListItemIcon
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <img
                            src="manu.webp"
                            alt="Dissertation Icon"
                            style={{ width: 40, height: 40 }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Typography
                              sx={{
                                fontSize: isSmallScreen ? "14px" : "17px",
                              }}
                            >
                              Manuscript
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem
                        button
                        onClick={() =>
                          handleRoute("/research-methodology-services")
                        }
                      >
                        <ListItemIcon
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <img
                            src="5528841.webp"
                            alt="Dissertation Icon"
                            style={{ width: 40, height: 40 }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Typography
                              sx={{
                                fontSize: isSmallScreen ? "14px" : "17px",
                              }}
                            >
                              Research Methodology
                            </Typography>
                          }
                        />
                      </ListItem>
                    </List>
                  </Grid>
                </Grid>
              </Box>
            )}

            {/* <Button color="inherit" href="/blog">
              Blog
            </Button> */}
            <Button color="inherit" href="/contact-us">
              Contact
            </Button>

          </Box>
        )}

        {/* Mobile drawer for navigation */}
        <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer}>
          <List sx={{ width: 250 }}>
            <ListItem button onClick={() => handleNavigation("/")}>
              <ListItemText primary="Home" />
            </ListItem>
            <ListItem button onClick={() => handleNavigation("/About")}>
              <ListItemText primary="About" />
            </ListItem>
            <ListItem button onClick={toggleMegaMenuDrawer}>
              <ListItemText primary="Services" />
              {megaMenuDrawerOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={megaMenuDrawerOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  sx={{ pl: 4 }}
                  onClick={() =>
                    handleNavigation("/dissertation-writing-services")
                  }
                >
                  <ListItemIcon>
                    <img
                      src="4725551.webp"
                      alt="Dissertation Icon"
                      style={{ width: 35, height: 35 }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Dissertation" />
                </ListItem>
                <ListItem
                  button
                  sx={{ pl: 4 }}
                  onClick={() => handleNavigation("/coursework-writing")}
                >
                  <ListItemIcon>
                    <img
                      src="courses.webp"
                      alt="Coursework Icon"
                      style={{ width: 35, height: 35 }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Coursework" />
                </ListItem>
                <ListItem
                  button
                  sx={{ pl: 4 }}
                  onClick={() => handleNavigation("/data-analysis-services")}
                >
                  <ListItemIcon>
                    <img
                      src="data.webp"
                      alt="Data Analysis Icon"
                      style={{ width: 35, height: 35 }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Data Analysis" />
                </ListItem>
                <ListItem
                  button
                  sx={{ pl: 4 }}
                  onClick={() => handleNavigation("/project-report-writing")}
                >
                  <ListItemIcon>
                    <img
                      src="edit.webp"
                      alt="Editing Services Icon"
                      style={{ width: 35, height: 35 }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Project writing services" />
                </ListItem>
                <ListItem
                  button
                  sx={{ pl: 4 }}
                  onClick={() => handleNavigation("/publication-services")}
                >
                  <ListItemIcon>
                    <img
                      src="9490625.webp"
                      alt="Courses Icon"
                      style={{ width: 35, height: 35 }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Publication" />
                </ListItem>
                <ListItem
                  button
                  sx={{ pl: 4 }}
                  onClick={() => handleNavigation("/literature-review-writing")}
                >
                  <ListItemIcon>
                    <img
                      src="lit.webp"
                      alt="Literature Review Icon"
                      style={{ width: 35, height: 35 }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Literature Review" />
                </ListItem>
                <ListItem
                  button
                  sx={{ pl: 4 }}
                  onClick={() => handleNavigation("/manuscript-preparation")}
                >
                  <ListItemIcon>
                    <img
                      src="manu.webp"
                      alt="Dissertation Icon"
                      style={{ width: 35, height: 35 }}
                    />
                  </ListItemIcon>
                  <ListItemText primary=" Manuscript" />
                </ListItem>
                <ListItem
                  button
                  sx={{ pl: 4 }}
                  onClick={() =>
                    handleNavigation("/research-methodology-services")
                  }
                >
                  <ListItemIcon>
                    <img
                      src="5528841.webp"
                      alt="Dissertation Icon"
                      style={{ width: 35, height: 35 }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Research Methodology" />
                </ListItem>
              </List>
            </Collapse>
            {/* <ListItem button onClick={() => handleNavigation("/blog")}>
              <ListItemText primary="Blog" />
            </ListItem> */}
            <ListItem button onClick={() => handleNavigation("/contact-us")}>
              <ListItemText primary="Contact" />
            </ListItem>

          </List>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
